import { startAudio } from "../../../services/assetsGenerationAPI";

export const handleStartGeneratingAudio = async ({
  publicationId,
  token,
  audioLevel,
  audioDuration,
  audioVoice,
  setActiveTasks,
  setTaskStatus,
  setAlert,
  setupWebSocket,
  setOpenAudioSummaryDialog,
  audioId = null,
  setRefreshTrigger = null,
}) => {
  try {
    const uniqueId = "pending";
    setActiveTasks((prev) => {
      const nextArr = [...(prev.audio || [])];
      if (!nextArr.includes(uniqueId)) nextArr.push(uniqueId);
      return { ...prev, audio: nextArr };
    });
    localStorage.setItem("activeTasks", "true");
    setTaskStatus(prev => ({
      ...prev,
      audio: {
        ...(prev.audio || {}),
        [uniqueId]: { progress: 0, status: "queued", publicationId: Number(publicationId) }
      }
    }));

    const result = await startAudio(publicationId, token, {
      audioLevel,
      audioLength: audioDuration,
      audioVoice
    }, audioId);

    if (result.error) {
      setAlert({ severity: "warning", message: result.error });
      setActiveTasks(prev => ({ ...prev, audio: (prev.audio || []).filter(id => id !== "pending") }));
      setTaskStatus(prev => { const n = { ...prev }; if (n.audio) { n.audio = { ...n.audio }; delete n.audio["pending"]; } return n; });
    } else if (result.task_id) {
      setActiveTasks(prev => ({ ...prev, audio: (prev.audio || []).filter(id => id !== "pending") }));
      setTaskStatus(prev => { const n = { ...prev }; if (n.audio) { n.audio = { ...n.audio }; delete n.audio["pending"]; } return n; });
      setupWebSocket(result.task_id, "audio", publicationId, result.project_id || null, (message, severity) => {
        setAlert({ severity, message });
      });
      setAlert({
        severity: "success",
        message: "Audio Summary Generation Started",
      });
      if (setRefreshTrigger) {
        setRefreshTrigger(prev => prev + 1);
      }
    }
    setOpenAudioSummaryDialog(false);
  } catch (error) {
    setAlert({
      severity: "warning",
      message:
        "Failed to start Audio summary generation. Please try again.",
    });
    setActiveTasks(prev => ({ ...prev, audio: (prev.audio || []).filter(id => id !== "pending") }));
    setTaskStatus(prev => { const n = { ...prev }; if (n.audio) { n.audio = { ...n.audio }; delete n.audio["pending"]; } return n; });
  }
  setOpenAudioSummaryDialog(false);
};

export const handleOpenAudioSummaryDialog = (setOpenAudioSummaryDialog) => {
  setOpenAudioSummaryDialog(true);
};

export const handleCloseAudioSummaryDialog = (setOpenAudioSummaryDialog) => {
  setOpenAudioSummaryDialog(false);
};
